// Module
var code = "<react-component name=\"BulkAddAttendeesList\"></react-component>\n";
// Exports
module.exports = code;